App.directive('setHeightFull', ['$window', function($window) {
    return {
        link: link,
        restrict: 'A'
    };

    function link(scope, elem, attrs) {
        function onResize() {
            var clientHeight = window.innerHeight;
            elem[0].style['min-height'] = clientHeight + 'px';
        }

        angular.element(document).ready(function() {
            onResize();
        });

        angular.element($window).on('resize', function() {
            onResize();
        });
    };
}]);